import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal-contenido" }
const _hoisted_3 = { class: "form-grupo" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-grupo" }
const _hoisted_6 = { class: "cambiar-nombre-label" }
const _hoisted_7 = { class: "botones" }

import { ref, watch } from 'vue'
import { ENFOQUES, type Enfoque } from '@/utils/enfoque'


export default /*@__PURE__*/_defineComponent({
  __name: 'VersionarModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ["confirmar", "cancelar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Creación de una versión nueva a partir de otra.
 *
 * Copia los INDICADORES; la estructura no se re-clona porque es del modelo y se
 * comparte.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const cambiarNombre = ref(false)
const nuevoNombre = ref('')
const enfoque = ref<Enfoque>('general')

watch(() => props.visible, (v) => {
  if (v) {
    cambiarNombre.value = false
    nuevoNombre.value = ''
    enfoque.value = 'general'
  }
})

function confirmar() {
  const nombreFinal = cambiarNombre.value && nuevoNombre.value.trim() ? nuevoNombre.value.trim() : undefined
  emit('confirmar', { nuevoNombre: nombreFinal, enfoque: enfoque.value })
}

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "modal-titulo" }, "Versionar Modelo", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mensaje" }, " Se creará una nueva versión en blanco del modelo, sin indicadores. Podrás agregarlos desde cero. Elige el enfoque de la nueva versión. ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              class: "form-label",
              for: "enfoque-version"
            }, "Enfoque de la versión", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "enfoque-version",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((enfoque).value = $event)),
              class: "form-input"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ENFOQUES), (e) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: e.value,
                  value: e.value
                }, _toDisplayString(e.label), 9, _hoisted_4))
              }), 128))
            ], 512), [
              [_vModelSelect, enfoque.value]
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "enfoque-ayuda" }, " Se mostrarán solo los aspectos de este enfoque (más los “General”). Los aspectos de otros enfoques quedan ocultos en la versión. ", -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cambiarNombre).value = $event)),
                class: "cambiar-nombre-check"
              }, null, 512), [
                [_vModelCheckbox, cambiarNombre.value]
              ]),
              _cache[6] || (_cache[6] = _createTextVNode(" ¿Desea cambiar el nombre del modelo? "))
            ]),
            (cambiarNombre.value)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((nuevoNombre).value = $event)),
                  type: "text",
                  class: "form-input",
                  placeholder: "Nuevo nombre del modelo"
                }, null, 512)), [
                  [_vModelText, nuevoNombre.value]
                ])
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn salir",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('cancelar')), ["stop"]))
            }, "Cancelar"),
            _createElementVNode("button", {
              class: "btn guardar",
              onClick: _withModifiers(confirmar, ["stop"])
            }, "Confirmar")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})